import { render, staticRenderFns } from "./DcCreate.vue?vue&type=template&id=defb2250"
import script from "./DcCreate.vue?vue&type=script&lang=js"
export * from "./DcCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports